import axios from 'axios';

import { withHost, pipePromise, handleStatuses } from 'utils';

export const uploadImage = pipePromise(
  ({ url, file }) =>
    axios.put(url, file, {
      headers: {
        'Content-Type': file.type,
      },
    }),
  handleStatuses()
);

export const fetchImageUploadUrl = pipePromise(
  ({ fileName, contentType, token, publisherId }) => {
    const apiUrl = withHost('/files/upload');

    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        ContentType: contentType,
        Filename: fileName,
      }),
    });
  },
  handleStatuses(),
  (response) => response.text()
);
